import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Button} from "react-bootstrap-v5";
import './buttons.scss'

const ButtonIconValidate = ({onClick, selected}) => (
    <Button className={`button-icon-validate ${selected}`} onClick={onClick}><FontAwesomeIcon icon="check"/></Button>
);

export default ButtonIconValidate;